// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"47e21cce","647":"d8d1e6fe","717":"e7a7e74d"}[chunkId] + ".chunk.js";
};